import { createFileRoute, redirect } from "@tanstack/react-router";

/** The template's demo dashboard was replaced by the Briefing; old links keep working. */
// oxlint-disable-next-line rules/require-route-crumb -- redirect-only route, never rendered.
export const Route = createFileRoute("/(private)/dashboard/")({
  beforeLoad: () => {
    throw redirect({ to: "/briefing" });
  },
});
